import React, { useState } from 'react';
import { 
  Box, 
  Button, 
  TextField, 
  Typography, 
  Container, 
  Paper, 
  Link,
  CircularProgress,
  Alert
} from '@mui/material';
import { useAuth } from '../../lib/supabase/AuthContext';
import { useNavigate } from 'react-router-dom';

interface LoginProps {
  onSwitchToSignUp: () => void;
  onSwitchToForgotPassword: () => void;
}

const Login: React.FC<LoginProps> = ({ onSwitchToSignUp, onSwitchToForgotPassword }) => {
  const { signIn, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email || !password) {
      setError('Veuillez remplir tous les champs');
      return;
    }
    
    try {
      setError(null);
      const { error: signInError, data } = await signIn(email, password);
      
      if (signInError) {
        console.error('Erreur de connexion:', signInError);
        setError('Erreur de connexion: ' + signInError.message);
      } else if (data?.user) {
        console.log('Connexion réussie, redirection vers le dashboard');
        navigate('/');
      }
    } catch (err: any) {
      console.error('Erreur:', err);
      setError('Une erreur est survenue: ' + err.message);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Paper 
        elevation={3} 
        sx={{ 
          mt: 8, 
          p: 4, 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          borderRadius: 2
        }}
      >
        <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
          Connexion
        </Typography>
        
        {error && (
          <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
            {error}
          </Alert>
        )}
        
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Adresse email"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Mot de passe"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'Se connecter'}
          </Button>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            <Link 
              component="button" 
              variant="body2" 
              onClick={onSwitchToForgotPassword}
            >
              Mot de passe oublié ?
            </Link>
            <Link 
              component="button" 
              variant="body2" 
              onClick={onSwitchToSignUp}
            >
              Pas de compte ? S'inscrire
            </Link>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default Login; 